import styled from "styled-components";


export const WrapperColorPicker = styled.div`
  position: relative;
`;

export const LabelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ labelGap }) => labelGap ? `${labelGap}px` : "8px"};
  cursor: pointer;
`;

export const LabelOption = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  min-height: 22px;
  justify-content: space-between;
`;

export const ColorLabel = styled.span`
  color: rgb(155, 155, 155);
  margin-right: 5px;
  font-size: 12px;
  
`;

export const ColorInput = styled.div`
  display: flex;
  transition: 0.3s;
  border: 1px solid #ebebeb;
  border-radius: 3px;

  /* ${props =>
    props.open
      ? "height: auto; opacity: 1; width: auto;"
      : "width: 0; height: 0; opacity: 0;"} */
`;

export const ColorRef = styled.div`
  width: 25px;
  height: 25px;
  position: relative;

  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAIAAABMXPacAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjEwMPRyoQAAAkdJREFUeF7t21tuwlAMhOHsf3HdUlspqChq8mBk5EPm4/kIEV9mjn+T7evi833xcX6PQFd8NgHtDWg1nhLwiFhXRUvAcEAlQAKOzVytiLTzPGC4YyRgOgFT7p8mNVfPu0nAHoGpgpCARwVKwLAWS4AEuL+fdcG7PZIH8IBj3b274lb7foPYsPdIgARkm78O0AE64HQIXO22cNffQ4JIULgE3bW1p+BaNZ5QBBQRjiKqLeN87waNBJEgEnSqKp9yi/h0SSRB0xKk0v09/aAiaQWBBWFB4SworeVXe14SRIJIkI3YbwSmBjqD2PQgNpX51cxw6vfoAB2AhqKhXlF6dkGaJ/EAHhDuAVPXrzSpuXpeLAgLwoKwoEkWxAPshO2EJ15QdgvaI+AWNH0LUom9f7atxhOKgCLCUUS1ZZzvlSwSRIJIkI2YjVjwRgwLwoKwICxo8K+JJIgEkSASRIL+uiBNEu0D7AOgCCgCighGEfh+L9+vxtM+wD6ACTNhJhxswmmT52rPaxKenoRXq4i036MDdIA3ZLwh4w2ZZxfwgGFNjEtAFR453wvvwDgwDowD48C4YBjHVHtNtRpPJsyEw004bfBZ7XnR0OHJXwIkAI6Go+FoOPpfF1QHCudfG+iY8LQJq9zXKrdrnoAioIhwFEGCSNChBdIKggfwAB5gJzy5E+66z6Zpd9fzmoSnJ2EdsEegq6Kr8dQBOsBCxkKGBFnIWMhcuHDVVKvnoQgoAoqAIiZRxNQAUtXKu57nATyAB/AAHpD7itIP7enqFX4nQcQAAAAASUVORK5CYII=), rgb(172 30 30 / 67%);
  background-size: 78px;

  border-right: 1px solid #ebebeb;
  border-radius: 2px;
  cursor: pointer;
  z-index: 1;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 25px;
    border-radius: 2px;
    
    background-color: ${(props) =>
    `rgba(${props.color.r},${props.color.g},${props.color.b},${props.color.a})`};
  }

`;

export const ColorEntry = styled.input`
  padding: 3px 3px;
  font-size: 11px;
  text-align: center;
  color: #606060;
  width: 62px;
  border: 0;
  /* border-radius: 2px; */
  font-weight: 500;
  background: #fff;
  z-index: 1;
  /* border: 1px solid rgb(201, 201, 201); */

  &:focus {
    border: 0;
    outline: 0;
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
  }
`;

export const LabelTitle = styled.div`
  font-size: ${({ fontSize }) => fontSize ? `${fontSize}px` : "12px"};
  color: #252525;
  /* padding-right: 8px;   */
`;

export const Picker = styled.div`
  display: flex;
  width: 100%;
  /* padding: 10px 0; */
  box-sizing: initial;
  background: transparent;
`;

export const SaturationContainer = styled.div`
  width: 100%;
  padding-bottom: 150px;
  position: relative;
  overflow: hidden;
  display: inline-block;
`;

export const SliderContainer = styled.div`
  position: relative;
  width: 24px;
  height: 150px;
  overflow: visible;
  display: inline-block;
  margin-left: 6px;
`;

export const PickerColor = styled.div`

  visibility: hidden;
  opacity: 0;

  height: 0;
  overflow: hidden;
  width: 190px;
  height: 160px;
  transition: 0.3s;

  position: absolute;
  top: 38px;
  /* top: ${props => (props.open ? "32px" : "42px")}; */
  right: 0;
  padding: 5px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 1px 1px 3px rgb(0 0 0 / 25%);
  z-index: 99;

  &.OpenedPicker {
    top: 32px;
    visibility: visible;
    opacity: 1;
  }


  /* > div {
    margin-top: 10px;
    transition: 0.3s;
    opacity: ${props => (props.open ? 1 : 0)};
  } */
`;

export const defaultStyles = {
  Saturation: {
    radius: "3px",
    shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)",
  },
  Hue: {
    radius: "2px",
    shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)",
    checkboard: {
      overflow: "visible",
    },
    container: {
      margin: 0,
    },
    slider: {
      width: 20,
      height: 3,
      marginTop: 0,
      transform: "translate3d(-2px, -1.5px, 0)",
    },
  },
  Alpha: {
    radius: "2px",
    shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)",
    checkboard: {
      overflow: "visible",
    },
    container: {
      margin: 0,
    },
    slider: {
      width: 20,
      height: 3,
      marginTop: 0,
      transform: "translate3d(-2px, -1.5px, 0)",
    },
  },
};
